module.exports = {"title":"Enter your customer code <1 /> to access your offer portal"}